import { render, staticRenderFns } from "./PanelAboutSchool.vue?vue&type=template&id=6fffb282&scoped=true"
import script from "./PanelAboutSchool.vue?vue&type=script&lang=js"
export * from "./PanelAboutSchool.vue?vue&type=script&lang=js"
import style0 from "./PanelAboutSchool.vue?vue&type=style&index=0&id=6fffb282&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fffb282",
  null
  
)

export default component.exports